import React from 'react';
import PropTypes from 'prop-types';

function ClockIcon({ className = '', ...props }) {
  return (
    <svg fill='none' stroke='currentColor' viewBox='0 0 24 24' className={className} {...props}>
      <circle cx='12' cy='12' r='10' />
      <polyline points='12 6 12 12 16 14' />
    </svg>
  );
}

ClockIcon.propTypes = {
  className: PropTypes.string,
};

export default ClockIcon;
